import {
  Component,
  Input,
  HostBinding,
  HostListener,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { resolveThemeCssClass } from "../lib/helper/panel-settings";
import { ICapitalizeTitle } from "src/app/shared/interface/capitalize-title";
import { IPanelSettings } from "../lib/core/interface/panel-settings";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { IContactPanelItemData } from "./components/contact-panel-item/contact-panel-item.component";
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';

interface IContactPanelData extends ICapitalizeTitle {
  title: IUProperty<string>;
  contacts: IUProperty<IContactPanelItemData[]>;

  titleStyleSettings?: ITitleStyleSettings;
  panelSettings: IPanelSettings;
}

@Component({
  selector: "app-contact-panel",
  templateUrl: "./contact-panel.component.html",
  styleUrls: ["./contact-panel.component.less"],
})
export class ContactPanelComponent {
  @Input() data: IContactPanelData;
  @ViewChild("panelEl", { static: false }) panelEl: ElementRef<HTMLElement>;
  @ViewChild("titleEl", { static: false }) titleEl: ElementRef<HTMLElement>;
  @HostBinding("class") get hostClasses() {
    return resolveThemeCssClass(this.data.panelSettings);
  }
  loadMedia: boolean = false;
  scrollPosition: number = null;

  @HostListener("window:scroll", []) onWindowScroll() {
    this.scrollPosition = window.pageYOffset;
    if (
      this.scrollPosition + window.outerHeight >
      this.panelEl.nativeElement.offsetTop
    ) {
      this.loadMedia = true;
    }
  }

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.scrollPosition = window.pageYOffset;
    if (
      this.scrollPosition + window.outerHeight >
      this.panelEl.nativeElement.offsetTop
    ) {
      this.loadMedia = true;
    }

    this.setCustomThemeProperties(this.data);
  }

  private setCustomThemeProperties(d: IContactPanelData) {
    if (d.capitalizeTitle && d.capitalizeTitle.value) {
      this.titleEl.nativeElement.style.textTransform = "uppercase";
    }

    applyTitleSettings(d, this.titleEl);
  }
}
